import config from '../../config';

export default {
  url: `${config.api.baseURL}/forms/:formId`,
  options: {
    method: 'POST'
  },
  transformer(data) {
    return data;
  }
};
